module.exports = __webpack_public_path__ + "static/media/FolderOpen.f09a2506.svg";